import api from "./axios";

export const createBanner = (payload) => {
  return api.post("/banners", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateBanner = (id, payload) => {
  return api.put(`/banners/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const reorderBanner = (orders) => {
  return api.put("/banners/reorder", {
    orders,
  });
};

export const getBanners = ({ bannerType, company_id } = {}) => {
  return api.get("/banners", {
    params: {
      banner_type: bannerType,
      company_id,
    },
  });
};



export const getBannerById = (id) => {
  return api.get(`/banners/${id}`);
};

export const deleteBanner = (id, payload) => {
  return api.delete(`/banners/${id}`, { data: payload });
};
